import { URL_PARAMETER } from "../constants";
import { cookieManagerInstance } from "../cookies";
import { CustomCookieIdentifier } from "../constants/ShortbreadConfig";
import { useEffect, useMemo, useState } from "react";
import { ExperimentalFlags } from "../types";

type ExperimentalFlagsFromUrlParamStatus = "in-progress" | "completed";

export const useSetExperimentalFlagsFromUrlParam = () => {
  const [status, setStatus] = useState<ExperimentalFlagsFromUrlParamStatus>(
    "in-progress"
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(document.location.search);
    const legacyFlag = urlParams.get(URL_PARAMETER.LEGACY);
    setStatus("in-progress");
    // If the experimentalToolbar URL parameter is empty, we will use the previous setting
    if (legacyFlag != null) {
      let experimentalFlags: ExperimentalFlags;
      try {
        experimentalFlags = JSON.parse(
          cookieManagerInstance.getSessionStorage(
            CustomCookieIdentifier.EXPERIMENTAL.name
          ) ?? "{}"
        );
      } catch {
        experimentalFlags = {};
      }

      cookieManagerInstance.setSessionStorage(
        CustomCookieIdentifier.EXPERIMENTAL.name,
        JSON.stringify({
          ...experimentalFlags,
          legacy: /true/i.test(legacyFlag),
        } as ExperimentalFlags)
      );
    }
    setStatus("completed");
  }, []);

  return status;
};
